import React, { useState, useEffect } from 'react';
import {
  CRUDLayout,
  Input,
  InputSearch,
  // ExportButton,
  CreateButton,
  ActionButton,
  DataStatus,
  CreateModal,
  UpdateModal,
  DeleteModal,
  UpdateButton,
  DeleteButton,
  Switch,
  SelectSearch,
  Alert,
  Pagination,
  THead,
  Tr,
  ThFixed,
  Th,
  TBody,
  TdFixed,
  Td,
} from '../../../components';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Axios from 'axios';
import { GudangApi } from '../../../api';
import { PageNumber, TableNumber } from '../../../utilities';
import { Modal } from 'react-bootstrap';
import { useIsGuest } from 'hooks';

const Gudang = ({ setNavbarTitle }) => {
  // Title
  const title = 'Master Gudang';
  const isGuest = useIsGuest();

  // STATE LOADING
  const [isLoading, setIsLoading] = useState(true);

  // STATE SEARCHING
  const [isSearching, setIsSearching] = useState(false);
  const [searchKey, setSearchKey] = useState('');

  // MODALS SHOW STATE
  const [isCreateForm, setIsCreateForm] = useState(false); // MODAL TAMBAH STATE
  const [isUpdateForm, setIsUpdateForm] = useState(false); // MODAL UPDATE STATE
  const [isDeleteData, setIsDeleteData] = useState(false); // MODAL HAPUS STATE

  // STATE DATA GUDANG
  const [data, setData] = useState([]);
  // const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [dataLength, setDataLength] = useState(10);
  const [totalData, setTotalData] = useState('');
  // STATE MENAMPUNG DATA YANG AKAN DI UPDATE
  const [updateData, setUpdateData] = useState([]);
  // STATE MENAMPUNG DATA YANG AKAN DI HAPUS
  const [deleteData, setDeleteData] = useState([]);
  // STATE MENAMPUNG DATA KARYAWAN
  const [karyawanData, setKaryawanData] = useState([]);
  // STATE MENAMPUNG DATA UNIT PRODUKSI
  const [unitOrganisasiData, setUnitOrganisasiData] = useState([]);
  // STATE MENAMPUNG GENERATE KODE ITEM
  const [kodeItem, setKodeItem] = useState([]);

  // ALERT STATE
  const [showAlert, setShowAlert] = useState(false);
  // KONFIGURASI ALERT
  const [alertConfig, setAlertConfig] = useState({
    variant: 'primary',
    text: '',
  });

  // FUNCTION GET DATA DARI SERVER
  const getData = () => {
    setIsLoading(true);
    setIsSearching(false);

    Axios.all([
      GudangApi.getPage(page, dataLength, searchKey),
      GudangApi.getKaryawan(),
      GudangApi.getUnitOrganisasi(),
      GudangApi.generateKodeItem(),
    ])
      .then(
        Axios.spread((res, karyawan, unit_org, kodeItem) => {
          setData(res?.data?.data);
          setTotalData(res?.data?.data_count);
          setKaryawanData(karyawan?.data?.data);
          setUnitOrganisasiData(unit_org?.data?.data);
          setKodeItem(kodeItem?.data?.data);
          setTotalPage(res?.data?.total_page);
        })
      )
      .catch((err) => alert(err))
      .finally(() => {
        if (searchKey != '') {
          setAlertConfig({
            variant: 'primary',
            text: `Hasil Pencarian : ${searchKey}`,
          });
          setShowAlert(true);
        }
        setIsLoading(false);
      });
  };

  // FUNCTION SWITCH HIDDEN DATA
  const changeDataStatus = (status, id) => {
    setIsLoading(true);

    const value = {
      id_gudang: id,
    };

    const onLoadedSuccess = () => {
      setIsSearching(false);
      setAlertConfig({
        variant: 'primary',
        text: 'Ubah status data berhasil',
      });
      setShowAlert(true);
    };

    const onLoadedFailed = () => {
      setIsSearching(false);
      setAlertConfig({
        variant: 'danger',
        text: 'Ubah status data gagal',
      });
      setShowAlert(true);
    };

    status === true
      ? GudangApi.show(value)
          .then(() => onLoadedSuccess())
          .catch(() => onLoadedFailed())
          .finally(() => getData())
      : GudangApi.hide(value)
          .then(() => onLoadedSuccess())
          .catch(() => onLoadedFailed())
          .finally(() => getData());
  };

  // FUNCTION CARI DATA DARI SERVER
  const searchData = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const key = searchKey; // SearchKey Value as key

    GudangApi.search(key)
      .then((res) => {
        setData(res.data.data);
        setTotalPage(res.data.total_page);
      })
      .catch((err) => alert(err))
      .finally(() => {
        setIsSearching(true);
        setIsLoading(false);
        setAlertConfig({
          variant: 'primary',
          text: `Hasil Pencarian : ${key}`,
        });
        setShowAlert(true);
      });
  };

  // ON COMPONENT MOUNT
  useEffect(() => {
    setNavbarTitle(title); // SET JUDUL NAVBAR
    getData(); // GET DATA DARI SERVER

    return () => {
      setIsLoading(false);
      setIsSearching(false);
    };
  }, [setNavbarTitle, page, dataLength, searchKey]);

  // FORMIK VALIDATION SCHEMA DENGAN YUP VALIDATION
  const formValidationSchema = Yup.object().shape({
    kode_gudang: Yup.string().required('Masukkan kode Gudang'),
    nama_gudang: Yup.string().required('Masukkan nama Gudang'),
    alamat_gudang: Yup.string().required('Masukkan Alamat Gudang'),
    // keterangan_gudang: Yup.string().required("Masukkan Keterangan"),
    id_unit_organisasi: Yup.string().required('Pilih Unit Organisasi'),
    id_karyawan: Yup.string().required('Pilih Penanggung Jawab'),
  });

  // MODAL TAMBAH COMPONENT
  const TambahModal = () => {
    const [idUnit, setIdUnit] = useState('');
    const [isUnitChange, setIsUnitChange] = useState(true);
    const [penanggungJawab, setPenanggungJawab] = useState([]);
    const [karyawanFilterd, setKaryawanFiltered] = useState([]);
    const [karyawanLoading, setKaryawanLoading] = useState(false);

    const getPenanggungJawab = () => {
      setKaryawanLoading(true);
      GudangApi.getKaryawan()
        .then((data) => {
          setPenanggungJawab(data.data.data);
        })
        .finally(() => setKaryawanLoading(false));
    };

    const UnitOrganisasiChange = (id_unit) => {
      const karyawanfilter = penanggungJawab.filter(
        (val) => val.id_unit_organisasi === id_unit
      );
      setKaryawanFiltered(karyawanfilter);
    };

    useEffect(() => {
      getPenanggungJawab();
    }, []);
    // FORMIK INITIAL VALUES
    const formInitialValues = {
      kode_gudang: kodeItem,
      nama_gudang: '',
      alamat_gudang: '',
      keterangan_gudang: '',
      id_unit_organisasi: '',
      id_karyawan: '',
    };

    // KIRIM DATA BARU KE SERVER
    const formSubmitHandler = (values) => {
      // setIsCreateForm(false);
      GudangApi.create(values)
        .then((res) => {
          // SUCCESS ALERT
          setShowAlert(true);
          setAlertConfig({
            variant: 'primary',
            text: 'Tambah data berhasil!',
          });
        })
        .catch((err) => {
          setShowAlert(true);
          setAlertConfig({
            variant: 'danger',
            text: `Tambah data gagal! (${err?.response?.data?.message})`,
          });
        })
        .finally(() => {
          // CLOSE MODAL
          setIsCreateForm(false);
          // TAMPILKAN ALERT
          // setShowAlert(true);
          // FETCH DATA DARI SERVER
          getData();
        });
    };
    return (
      <CreateModal
        show={isCreateForm}
        onHide={() => setIsCreateForm(false)}
        title={title}
      >
        <Formik
          initialValues={formInitialValues}
          validationSchema={formValidationSchema}
          onSubmit={formSubmitHandler}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            handleChange,
            handleSubmit,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <Modal.Body>
                <Input
                  label="Kode Gudang"
                  type="text"
                  name="kode_gudang"
                  placeholder="Kode Gudang"
                  value={values.kode_gudang}
                  readOnly={true}
                  onChange={handleChange}
                  error={errors.kode_gudang && touched.kode_gudang && true}
                  errorText={errors.kode_gudang}
                />

                <Input
                  label="Nama Gudang"
                  type="text"
                  name="nama_gudang"
                  placeholder="Nama Gudang"
                  value={values.nama_gudang}
                  onChange={handleChange}
                  error={errors.nama_gudang && touched.nama_gudang && true}
                  errorText={errors.nama_gudang}
                />

                <Input
                  label="Alamat Gudang"
                  type="text"
                  name="alamat_gudang"
                  placeholder="Alamat Gudang"
                  value={values.alamat_gudang}
                  onChange={handleChange}
                  error={errors.alamat_gudang && touched.alamat_gudang && true}
                  errorText={errors.alamat_gudang}
                />

                <Input
                  label="Keterangan Gudang"
                  type="text"
                  name="keterangan_gudang"
                  placeholder="Keterangan Gudang"
                  value={values.keterangan_gudang}
                  onChange={handleChange}
                  error={
                    errors.keterangan_gudang &&
                    touched.keterangan_gudang &&
                    true
                  }
                  errorText={errors.keterangan_gudang}
                />

                <SelectSearch
                  label="Unit Organisasi"
                  name="id_unit_organisasi"
                  placeholder="Pilih Unit Organisasi"
                  onChange={(val) => {
                    setFieldValue('id_unit_organisasi', val.value);
                    setIdUnit(val.value);
                    setIsUnitChange(false);
                    UnitOrganisasiChange(val.value);
                    getPenanggungJawab();
                  }}
                  // MAPPING OPTIONS
                  // OPTIONS BERUPA VALUE DAN LABEL
                  option={unitOrganisasiData
                    .filter((val) => val.is_hidden === false)
                    .map((val) => {
                      return {
                        value: val.id_unit_organisasi,
                        label: val.nama_unit_organisasi,
                      };
                    })}
                  error={
                    errors.id_unit_organisasi &&
                    touched.id_unit_organisasi &&
                    true
                  }
                  errorText={
                    errors.id_unit_organisasi &&
                    touched.id_unit_organisasi &&
                    errors.id_unit_organisasi
                  }
                />
                {karyawanLoading === true ? (
                  <small>Memuat Data....</small>
                ) : (
                  <SelectSearch
                    label="Penanggung Jawab"
                    name="id_karyawan"
                    placeholder={
                      isUnitChange !== false
                        ? 'Pilih Unit Organisasi Terlebih Dahulu'
                        : 'Pilih Penanggung Jawab'
                    }
                    isDisabled={isUnitChange}
                    onChange={(val) => {
                      setFieldValue('id_karyawan', val.value);
                    }}
                    // MAPPING OPTIONS
                    // OPTIONS BERUPA VALUE DAN LABEL
                    option={karyawanFilterd.map((val) => {
                      return {
                        value: val.id_karyawan,
                        label: val.nama_karyawan,
                      };
                    })}
                    error={errors.id_karyawan && touched.id_karyawan && true}
                    errorText={
                      errors.id_karyawan &&
                      touched.id_karyawan &&
                      errors.id_karyawan
                    }
                  />
                )}
              </Modal.Body>
              <Modal.Footer>
                <div className="d-flex justify-content-end">
                  <ActionButton
                    type="submit"
                    variant="primary"
                    text="Tambah"
                    className="mt-2 px-4"
                    loading={isSubmitting}
                  />
                </div>
              </Modal.Footer>
            </form>
          )}
        </Formik>
      </CreateModal>
    );
  };

  // MODAL UBAH COMPONENT
  const UbahModal = () => {
    const [penanggungJawab, setPenanggungJawab] = useState([]);
    const [karyawanFilterd, setKaryawanFiltered] = useState([]);
    const [karyawanLoading, setKaryawanLoading] = useState(false);

    const UnitOrganisasiChange = (id_unit) => {
      const karyawanfilter = penanggungJawab.filter(
        (val) => val.id_unit_organisasi === id_unit
      );
      setKaryawanFiltered(karyawanfilter);
    };

    const getPenanggungJawab = () => {
      setKaryawanLoading(true);
      GudangApi.getKaryawan()
        .then((data) => {
          setPenanggungJawab(data.data.data);
        })
        .finally(() => setKaryawanLoading(false));
    };

    const formInitialValues = {
      kode_gudang: updateData.kode_gudang,
      nama_gudang: updateData.nama_gudang,
      alamat_gudang: updateData.alamat_gudang,
      keterangan_gudang: updateData.keterangan_gudang,
      id_unit_organisasi: updateData.id_unit_organisasi,
      id_karyawan: updateData.id_karyawan,
    };

    useEffect(() => {
      UnitOrganisasiChange(formInitialValues.id_unit_organisasi);
    }, []);

    // KIRIM UPDATE DATA KE SERVER
    const formSubmitHandler = (values) => {
      const finalValues = {
        id_gudang: updateData.id_gudang,
        ...values,
      };
      GudangApi.update(finalValues)
        .then((res) => {
          // SUCCESS ALERT
          setShowAlert(true);
          setAlertConfig({
            variant: 'primary',
            text: 'Ubah data berhasil!',
          });
        })
        .catch((err) => {
          // const errMsg = Object.values(err.response?.data?.error) ?? []
          // ERROR ALERT
          setShowAlert(true);
          setAlertConfig({
            variant: 'danger',
            text: `Ubah data gagal! (${err?.response?.data?.message})`,
            // text: `Tambah data gagal! <ul> ${errMsg.map(e => `<li>${e}</li>`).join("")} </ul>`
          });
        })
        .finally(() => {
          // CLOSE UPDATE MODAL FORM
          setIsUpdateForm(false);
          // SHOW ALERT
          // setShowAlert(true);
          // FETCH DATA DARI SERVER
          getData();
        });
    };

    return (
      <UpdateModal
        show={isUpdateForm}
        onHide={() => setIsUpdateForm(false)}
        title={title}
      >
        <Formik
          initialValues={formInitialValues}
          validationSchema={formValidationSchema}
          onSubmit={formSubmitHandler}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            handleChange,
            handleSubmit,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <Modal.Body>
                <Input
                  label="Kode Gudang"
                  type="text"
                  name="kode_gudang"
                  placeholder="Kode Gudang"
                  value={values.kode_gudang}
                  readOnly={true}
                  onChange={handleChange}
                  error={errors.kode_gudang && touched.kode_gudang && true}
                  errorText={errors.kode_gudang}
                />

                <Input
                  label="Nama Gudang"
                  type="text"
                  name="nama_gudang"
                  placeholder="Nama Gudang"
                  value={values.nama_gudang}
                  onChange={handleChange}
                  error={errors.nama_gudang && touched.nama_gudang && true}
                  errorText={errors.nama_gudang}
                />

                <Input
                  label="Alamat Gudang"
                  type="text"
                  name="alamat_gudang"
                  placeholder="Alamat Gudang"
                  value={values.alamat_gudang}
                  onChange={handleChange}
                  error={errors.alamat_gudang && touched.alamat_gudang && true}
                  errorText={errors.alamat_gudang}
                />

                <Input
                  label="Keterangan Gudang"
                  type="text"
                  name="keterangan_gudang"
                  placeholder="Keterangan Gudang"
                  value={values.keterangan_gudang}
                  onChange={handleChange}
                  error={
                    errors.keterangan_gudang &&
                    touched.keterangan_gudang &&
                    true
                  }
                  errorText={errors.keterangan_gudang}
                />

                <SelectSearch
                  label="Unit Organisasi"
                  name="id_unit_organisasi"
                  placeholder="Pilih Unit Organisasi"
                  onChange={(val) => {
                    setFieldValue('id_unit_organisasi', val.value);
                    UnitOrganisasiChange(val.value);
                    getPenanggungJawab();
                  }}
                  // MAPPING OPTIONS
                  // OPTIONS BERUPA VALUE DAN LABEL
                  option={unitOrganisasiData
                    .filter((val) => val.is_hidden === false)
                    .map((val) => {
                      return {
                        value: val.id_unit_organisasi,
                        label: val.nama_unit_organisasi,
                      };
                    })}
                  // default value harus berupa: {{ label: 'masukan label', value: 'masukan value' }}
                  defaultValue={{
                    value: values.id_unit_organisasi ?? '',
                    label:
                      values.id_unit_organisasi !== ''
                        ? unitOrganisasiData.find(
                            (e) =>
                              e.id_unit_organisasi === values.id_unit_organisasi
                          )?.nama_unit_organisasi ?? 'Pilih Unit Organisasi'
                        : 'Pilih Unit Organisasi',
                  }}
                  error={
                    errors.id_unit_organisasi &&
                    touched.id_unit_organisasi &&
                    true
                  }
                  errorText={
                    errors.id_unit_organisasi &&
                    touched.id_unit_organisasi &&
                    errors.id_unit_organisasi
                  }
                />

                {karyawanLoading === true ? (
                  <small>Memuat Data....</small>
                ) : (
                  <SelectSearch
                    label="Kepala Penanggung Jawab"
                    name="id_karyawan"
                    placeholder="Pilih Kepala Penanggung Jawab"
                    onChange={(val) => {
                      setFieldValue('id_karyawan', val.value);
                    }}
                    // MAPPING OPTIONS
                    // OPTIONS BERUPA VALUE DAN LABEL
                    option={karyawanFilterd.map((val) => {
                      return {
                        value: val.id_karyawan,
                        label: val.nama_karyawan,
                      };
                    })}
                    // default value harus berupa: {{ label: 'masukan label', value: 'masukan value' }}
                    defaultValue={{
                      value: values.id_karyawan ?? '',
                      label:
                        values.id_karyawan !== ''
                          ? karyawanData.find(
                              (e) => e.id_karyawan === values.id_karyawan
                            )?.nama_karyawan ?? 'Pilih Kepala Unit'
                          : 'Pilih Kepala Unit',
                    }}
                    error={errors.id_karyawan && touched.id_karyawan && true}
                    errorText={
                      errors.id_karyawan &&
                      touched.id_karyawan &&
                      errors.id_karyawan
                    }
                  />
                )}
              </Modal.Body>
              <Modal.Footer>
                <div className="d-flex justify-content-end">
                  <ActionButton
                    type="submit"
                    variant="success"
                    text="Ubah"
                    className="mt-2 px-4"
                    loading={isSubmitting}
                  />
                </div>
              </Modal.Footer>
            </form>
          )}
        </Formik>
      </UpdateModal>
    );
  };

  // MODAL HAPUS COMPONENT
  const HapusModal = () => {
    // SET DATA ID YANG DIHAPUS
    const deleteValue = { id_gudang: deleteData.id_gudang };

    // MENANGANI DELETE BUTTON LOADING
    const [btnLoading, setBtnLoading] = useState(false);

    // DELETE DATA DARI SERVER
    const deleteDataHandler = () => {
      setBtnLoading(true);
      GudangApi.delete(deleteValue)
        .then(() => {
          // KONFIGURASI ALERT
          setShowAlert(true);
          setAlertConfig({
            variant: 'primary',
            text: 'Hapus data berhasil!',
          });
        })
        .catch((err) => {
          // KONFIGURASI ALERT
          setShowAlert(true);
          setAlertConfig({
            variant: 'danger',
            text: `Hapus data gagal! (${err?.response?.data?.message})`,
          });
        })
        .finally(() => {
          // CLOSE MODAL
          setIsDeleteData(false);
          // TAMPIL ALERT
          // setShowAlert(true);
          // FETCH DATA DARI SERVER
          getData();
        });
    };

    return (
      <DeleteModal
        show={isDeleteData}
        onHide={() => setIsDeleteData(false)}
        loading={btnLoading}
        onConfirm={deleteDataHandler}
        title={title}
      >
        <div>Kode Gudang : {deleteData.kode_gudang}</div>
        <div>Nama Gudang : {deleteData.nama_gudang}</div>
      </DeleteModal>
    );
  };

  // TABLE COMPONENT
  const Table = () => {
    return (
      <>
        <CRUDLayout.Table>
          <THead>
            <Tr className="text-center">
              <ThFixed>No</ThFixed>
              {!isGuest && <ThFixed>Aksi</ThFixed>}
              <Th>Kode Gudang</Th>
              <Th>Nama Gudang</Th>
              <Th>Unit Organisasi</Th>
              <Th>Penanggung Jawab</Th>
              <Th>Alamat</Th>
            </Tr>
          </THead>
          <TBody>
            {data.map((val, index) => {
              return (
                <Tr key={index}>
                  <TdFixed>{PageNumber(page, dataLength, index)}</TdFixed>
                  {!isGuest && (
                    <TdFixed>
                      <div className="d-flex justify-content-center">
                        <UpdateButton
                          onClick={() => {
                            setUpdateData(val);
                            setIsUpdateForm(true);
                          }}
                        />
                        <DeleteButton
                          onClick={() => {
                            setDeleteData(val);
                            setIsDeleteData(true);
                          }}
                        />

                        <Switch
                          id={val.id_gudang}
                          checked={val.is_hidden ? false : true}
                          onChange={() =>
                            changeDataStatus(val.is_hidden, val.id_gudang)
                          }
                        />
                      </div>
                    </TdFixed>
                  )}
                  <TdFixed>{val.kode_gudang}</TdFixed>
                  <Td>{val.nama_gudang}</Td>
                  <Td>{val.nama_unit_organisasi}</Td>
                  <Td>{val.nama_karyawan}</Td>
                  <Td>{val.alamat_gudang}</Td>
                </Tr>
              );
            })}
          </TBody>
        </CRUDLayout.Table>
        {!isSearching && (
          <Pagination
            dataLength={dataLength}
            dataPage={
              totalData <= 10
                ? data.length
                : data.map((res, index) => {
                    if (index == data.length - 1) {
                      return TableNumber(page, dataLength, index);
                    }
                  })
            }
            dataNumber={data.map((res, index) => {
              if (index == 0) {
                return TableNumber(page, dataLength, index);
              }
            })}
            dataCount={totalData}
            onDataLengthChange={(e) => {
              setDataLength(e.target.value);
              setPage(1);
            }}
            currentPage={page}
            totalPage={totalPage}
            onPaginationChange={({ selected }) => setPage(selected + 1)}
          />
        )}
      </>
    );
  };

  return (
    <CRUDLayout>
      <CRUDLayout.Head>
        <CRUDLayout.HeadSearchSection>
          <div className="d-flex mb-3">
            <InputSearch
              onChange={(e) => {
                setTimeout(() => {
                  setSearchKey(e.target.value);
                  setPage(1);
                }, 1000);
              }}
              onSubmit={(e) => e.preventDefault()}
            />
          </div>
        </CRUDLayout.HeadSearchSection>

        {/* Button Section */}
        <CRUDLayout.HeadButtonSection>
          {/* Button Export */}
          {/* <ExportButton /> */}
          {/* Button Tambah */}
          <CreateButton onClick={() => setIsCreateForm(true)} />
        </CRUDLayout.HeadButtonSection>
      </CRUDLayout.Head>

      {/* Alert */}
      <Alert
        show={showAlert}
        showCloseButton={true}
        variant={alertConfig.variant}
        text={alertConfig.text}
        onClose={() => setShowAlert(false)}
      />

      {isLoading ? (
        <DataStatus loading={isLoading} text="Memuat Data" />
      ) : !Array.isArray(data) ? (
        <DataStatus text="Tidak dapat memuat data" />
      ) : data.length > 0 ? (
        <Table />
      ) : (
        <DataStatus text="Tidak ada data" />
      )}

      {/* MODAL */}
      <TambahModal />
      <UbahModal />
      <HapusModal />
    </CRUDLayout>
  );
};

export default Gudang;
